import { useEffect, useState } from 'react';

/**
 * Custom hook to track offline mode and API cache usage
 * Listens to network status and custom cache events
 */
export const useOfflineStatus = () => {
  const [isOffline, setIsOffline] = useState(false);//!navigator.onLine);
  const [isUsingCache, setIsUsingCache] = useState(false);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);
    
    // Custom event when services use cached data
    const handleCacheUsed = () => {
      setIsUsingCache(true);
      // Reset after 5 seconds
      setTimeout(() => setIsUsingCache(false), 5000);
    };

    /*
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    window.addEventListener('api:cache-used', handleCacheUsed);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('api:cache-used', handleCacheUsed);
    };
    */
  }, []);

  return { isOffline, isUsingCache };
};

/**
 * Notify that cached data is being used
 * Call this from services when falling back to cache/mock data
 */
export const notifyCacheUsed = () => {
  window.dispatchEvent(new CustomEvent('api:cache-used'));
};
